export default "__VITE_ASSET__DPWSFxXX__"